const styles = {
  // Main container styles - Dark elegant background
  mainContainer: {
    maxWidth: '1550px',
    margin: '0 auto',
    marginTop: '0px',
    marginBottom: '40px',
    padding: '20px',
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    //background: 'linear-gradient(135deg, #2c1810 0%, #3d2817 50%, #4a2c1a 100%)',
    minHeight: '100vh',
    position: 'relative'
  },
  // recyclebin main conatiner
  mainContainerre: {
    maxWidth: '1480px',
    margin: '0 auto',
    padding: '20px',
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    //background: 'linear-gradient(135deg, #2c1810 0%, #3d2817 50%, #4a2c1a 100%)',
    minHeight: '100vh',
    position: 'relative'
  },

  welcomeContainer: {
    maxWidth: '500px',
    padding: '6px 20px', // compact height
    margin: '8px auto', // centers horizontally & sets small top/bottom margin
    borderRadius: '20px',
    boxShadow: '0 10px 20px rgba(0,0,0,0.1), 0 0 0 1px rgba(2,62,138,0.1)',
    background: 'linear-gradient(135deg, #f0f8ff 0%, #e6f3ff 50%, #dceeff 100%)',
    border: '1px solid rgba(2,62,138,0.15)',
    position: 'relative',
    overflow: 'hidden',
    textAlign: 'center',
    whiteSpace: 'nowrap', // ⬅️ prevents wrapping
    fontSize: '16px',
    fontWeight: '500',
    color: '#023e8a'
  },
  // recycleHeader: {
  //   padding: '6px 16px',        // ⬅️ even more compact
  //   borderRadius: '12px',
  //   backgroundColor: '#e6f3ff',
  //   color: '#003566',
  //   boxShadow: '0 3px 8px rgba(0, 0, 0, 0.06)',
  //   display: 'inline-block',
  //   margin: '8px auto',         // centers with margin
  //   textAlign: 'center',
  // },
  heading: {
    margin: 0,
    marginTop:'-55px',
    marginBottom:'10px',               // ⬅️ remove vertical space
    fontSize: '25px',        // ⬅️ reduce size
    fontWeight: '700',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: '#023e8a',        // use solid color for better visibility
    letterSpacing: '1px'
  },

  addNewContainer: {
    textAlign: 'left'
  },

  addNewButton: {
    background: 'linear-gradient(135deg, #0077b6 0%, #023e8a 100%)',
    //border: 'none',
    color: '#fff',
    fontWeight: '600',
    textDecoration: 'none',
    cursor: 'pointer',
    fontSize: '16px',
    padding: '12px 24px',
    borderRadius: '12px',
    marginBottom:'10px',
    marginLeft:'10px',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '0 4px 12px rgba(0,119,182,0.3)',
    border: '1px solid rgba(255,255,255,0.2)',
    ':hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 20px rgba(0,119,182,0.4)'
    }
  },

  recycleButton: {
    background: 'linear-gradient(135deg, #034078 0%, #023e8a 100%)',
    color: '#fff',
    padding: '12px 24px',
    borderRadius: '12px',
    fontWeight: '600',
    fontSize: '16px',
    cursor: 'pointer',
    marginLeft: '15px',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '0 4px 12px rgba(3,64,120,0.3)',
    border: '1px solid rgba(255,255,255,0.2)'
  },

  // Form container styles - Light elegant card
  formContainer: {
    backgroundColor: '#fafcff',
    padding: '40px',
    borderRadius: '20px',
    boxShadow: '0 20px 40px rgba(0,0,0,0.12), 0 0 0 1px rgba(2,62,138,0.08)',
    marginBottom: '30px',
    border: '1px solid rgba(2,62,138,0.12)',
    background: 'linear-gradient(135deg, #fafcff 0%, #f0f8ff 100%)',
    marginTop: '-45px',
  },

  form: {
    width: '100%'
  },

  formGroup: {
    marginBottom: '25px'
  },

  label: {
    display: 'block',
    marginBottom: '10px',
    fontWeight: '600',
    color: '#023e8a',
    fontSize: '16px',
    letterSpacing: '0.5px'
  },

  input: {
    width: '100%',
    padding: '16px 20px',
    border: '2px solid #b3d9ff',
    borderRadius: '12px',
    fontSize: '16px',
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'all 0.3s ease',
    backgroundColor: '#fff',
    color: '#023e8a',
    ':focus': {
      borderColor: '#0077b6',
      boxShadow: '0 0 0 4px rgba(0,119,182,0.1)'
    }
  },

  textarea: {
    width: '100%',
    padding: '16px 20px',
    border: '2px solid #b3d9ff',
    borderRadius: '12px',
    fontSize: '16px',
    outline: 'none',
    resize: 'vertical',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
    color: '#023e8a',
    minHeight: '80px',
    transition: 'all 0.3s ease'
  },

  fileInput: {
    width: '100%',
    padding: '16px 0',
    fontSize: '16px',
    color: '#023e8a'
  },

  formActions: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '20px',
    marginTop: '30px'
  },

  button: {
    background: 'linear-gradient(135deg, #0077b6 0%, #023e8a 100%)',
    color: '#fff',
    padding: '16px 32px',
    borderRadius: '16px',
    cursor: 'pointer',
    fontSize: '18px',
    fontWeight: '600',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '0 8px 20px rgba(0,119,182,0.3)',
    border: '1px solid rgba(255,255,255,0.2)',
    letterSpacing: '0.5px'
  },

  buttonDisabled: {
    background: 'linear-gradient(135deg, #cce7ff 0%, #b3d9ff 100%)',
    color: '#6ba3d0',
    padding: '16px 32px',
    border: 'none',
    borderRadius: '16px',
    cursor: 'not-allowed',
    fontSize: '18px',
    fontWeight: '600'
  },

  cancelButton1: {
    background: 'linear-gradient(135deg, #d67b7b 0%, #c45a5a 100%)',
    color: '#fff',
    padding: '16px 32px',
    border: 'none',
    borderRadius: '16px',
    cursor: 'pointer',
    fontSize: '18px',
    fontWeight: '600',
    boxShadow: '0 8px 20px rgba(214,123,123,0.3)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
  },

  cancelButton2: {
    background: 'linear-gradient(135deg, #d67b7b 0%, #c45a5a 100%)',
    color: '#fff',
    padding: '16px 32px',
    border: 'none',
    borderRadius: '16px',
    cursor: 'pointer',
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '15px',
    marginLeft:'15px',
    boxShadow: '0 8px 20px rgba(214,123,123,0.3)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
  },

  dropzone: {
    border: '3px dashed #0077b6',
    borderRadius: '16px',
    padding: '30px',
    textAlign: 'center',
    cursor: 'pointer',
    marginBottom: '20px',
    backgroundColor: '#f0f8ff',
    transition: 'all 0.3s ease',
    color: '#023e8a'
  },

  fileList: {
    listStyle: 'none',
    padding: 0,
    margin: 0
  },

  fileItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: 'linear-gradient(135deg, #f0f8ff 0%, #e6f3ff 100%)',
    padding: '12px 16px',
    marginBottom: '12px',
    borderRadius: '12px',
    border: '1px solid #b3d9ff'
  },

  removeButton: {
    background: 'transparent',
    border: 'none',
    color: '#c45a5a',
    fontWeight: '600',
    fontSize: '16px',
    cursor: 'pointer',
    padding: '4px 8px',
    borderRadius: '6px',
    transition: 'all 0.2s ease'
  },

  progressBarContainer: {
    width: '100%',
    height: '8px',
    backgroundColor: '#b3d9ff',
    borderRadius: '8px',
    marginTop: '8px',
    flex: 1,
    marginLeft: '16px',
    marginRight: '16px',
    overflow: 'hidden'
  },

  progressBar: {
    height: '100%',
    background: 'linear-gradient(90deg, #0077b6 0%, #023e8a 100%)',
    borderRadius: '8px',
    transition: 'width 0.3s ease'
  },

  // Filter container styles - Solid color instead of gradient
  filterContainer: {
    //background: '#023e8a',
    //background: '#216acaff',
    background:'#3E5879',
    //padding: '15px',
    borderRadius: '20px',
    boxShadow: '0 20px 40px rgba(2,62,138,0.25), inset 0 1px 0 rgba(255,255,255,0.1)',
    marginBottom: '20px',
    marginTop: '-40px',
    border: '1px solid rgba(0,119,182,0.2)',
    position: 'relative',
    overflow: 'hidden',
    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
  },

  sectionTitle: {
    color: '#ffffff',
    fontSize: '20px',
    marginBottom: '8px',
    marginLeft: '20px',
    fontWeight: '700',
    letterSpacing: '1px',
    textShadow: '0 2px 4px rgba(0,0,0,0.2)',
    transition: 'all 0.3s ease'
  },

  filterControls: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '25px',
    alignItems: 'center',
    background: 'rgba(255,255,255,0.1)',
    padding: '25px',
    borderRadius: '16px',
    backdropFilter: 'blur(15px)',
    border: '1px solid rgba(255,255,255,0.15)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.1)'
  },

  filterGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    transition: 'transform 0.2s ease'
  },

  filterLabel: {
    fontWeight: '600',
    color: '#ffffff',
    fontSize: '14px',
    letterSpacing: '0.5px',
    textShadow: '0 1px 2px rgba(0,0,0,0.2)',
    transition: 'color 0.3s ease'
  },

  filterRefresh: {
    marginTop: '26px',
    //background: 'linear-gradient(135deg, #0077b6 0%, #023e8a 100%)',
    background:'#1C325B',
    color: '#fff',
    fontSize: '20px',
    padding: '10px 16px',
    borderRadius: '12px',
    border: 'none',
    boxShadow: '0 4px 12px rgba(0,119,182,0.3)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    cursor: 'pointer',
    fontWeight: '600',
    position: 'relative',
    overflow: 'hidden'
  },

  filterSelect: {
    padding: '12px 16px',
    borderRadius: '12px',
    border: '2px solid rgba(255,255,255,0.2)',
    fontSize: '14px',
    backgroundColor: 'rgba(255,255,255,0.95)',
    minWidth: '140px',
    color: '#023e8a',
    fontWeight: '500',
    outline: 'none',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    ':focus': {
      borderColor: '#ffffff',
      boxShadow: '0 0 0 3px rgba(255,255,255,0.2)',
      transform: 'translateY(-1px)'
    }
  },

  filterActions: {
    display: 'flex',
    gap: '15px',
    marginLeft: 'auto'
  },

  applyButton: {
    //background: 'linear-gradient(135deg, #0077b6 0%, #023e8a 100%)',
    background:'#1C325B',
    color: '#fff',
    border: 'none',
    padding: '12px 24px',
    borderRadius: '12px',
    cursor: 'pointer',
    fontWeight: '600',
    fontSize: '14px',
    boxShadow: '0 4px 12px rgba(0,119,182,0.3)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    position: 'relative',
    overflow: 'hidden'
  },

  clearButton: {
    background: 'linear-gradient(135deg, #d67b7b 0%, #c45a5a 100%)',
    color: '#fff',
    border: 'none',
    padding: '12px 24px',
    borderRadius: '12px',
    cursor: 'pointer',
    fontWeight: '600',
    fontSize: '14px',
    boxShadow: '0 4px 12px rgba(214,123,123,0.3)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
  },

  // Records container styles - Light elegant table
  recordsContainer: {
    backgroundColor: '#fafcff',
    borderRadius: '20px',
    boxShadow: '0 20px 40px rgba(0,0,0,0.12), 0 0 0 1px rgba(2,62,138,0.08)',
    overflow: 'hidden',
    border: '1px solid rgba(2,62,138,0.12)'
  },

  tableContainer: {
    borderRadius: '20px',
    overflowX: 'auto'
  },

  table: {
    width: '100%',
    borderCollapse: 'collapse',
    backgroundColor: '#fff'
  },

  // Updated table header with solid color instead of gradient
  th: {
    //borderBottom: '3px solid #0077b6',
    padding: '18px 17px',
    //background: '#4079c4ff',
    background:'#4A628A',
    textAlign: 'center',
    fontWeight: '700',
    color: '#ffffff',
    fontSize: '14px',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    position: 'relative',
    fontFamily: 'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    textShadow: '0 2px 4px rgba(0,0,0,0.3)',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.1)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    ':hover': {
      background: '#034078',
      transform: 'translateY(-1px)'
    }
  },

  td: {
    padding: '16px 15px',
    borderBottom: '1px solid #e6f3ff',
    textAlign: 'center',
    fontSize: '14px',
    color: '#2d3748',
    backgroundColor: '#fff',
    //backgroundColor:'#FFF8F3',
    transition: 'background-color 0.2s ease'
  },

  showMoreLink: {
    color: '#0077b6',
    cursor: 'pointer',
    marginLeft: '8px',
    textDecoration: 'underline',
    fontWeight: '600',
    transition: 'color 0.2s ease'
  },

  editStatusIcon: {
    cursor: 'pointer',
    color: '#0077b6',
    fontSize: '18px',
    transition: 'color 0.2s ease'
  },

  viewButton: {
    padding: '8px 16px',
    //background: 'linear-gradient(135deg, #7bb3f0 0%, #5a9bd4 100%)',
    background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
    color: '#fff',
    textDecoration: 'none',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '600',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 8px rgba(123,179,240,0.3)'
  },

  deleteButton: {
    padding: '8px 16px',
    background: 'linear-gradient(135deg, #e57373 0%, #d32f2f 100%)',
    color: '#fff',
    cursor: 'pointer',
    border: 'none',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '600',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 8px rgba(229,115,115,0.3)'
  },

  // No records container
  noRecordsContainer: {
    padding: '80px 20px',
    textAlign: 'center',
    backgroundColor: '#fff'
  },

  noRecordsMessage: {
    fontSize: '20px',
    color: '#023e8a',
    fontWeight: '600',
    letterSpacing: '0.5px'
  },

  // Success/Error messages
  success: {
    marginTop: '25px',
    padding: '20px',
    background: 'linear-gradient(135deg, #e8f5e8 0%, #d4f0d4 100%)',
    color: '#2e7d32',
    border: '2px solid #a5d6a7',
    borderRadius: '16px',
    textAlign: 'center',
    fontWeight: '600',
    boxShadow: '0 4px 12px rgba(46,125,50,0.1)'
  },

  error: {
    marginTop: '25px',
    padding: '20px',
    background: 'linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)',
    color: '#c62828',
    border: '2px solid #ef9a9a',
    borderRadius: '16px',
    textAlign: 'center',
    fontWeight: '600',
    boxShadow: '0 4px 12px rgba(198,40,40,0.1)'
  },

  // Delete notification
  deleteNotification: {
    position: 'fixed',
    top: '60px',
    left: '50%',
    transform: 'translateX(-50%)',
    background: 'linear-gradient(135deg, #e8f5e8 0%, #d4f0d4 100%)',
    color: '#2e7d32',
    border: '2px solid #a5d6a7',
    borderRadius: '16px',
    padding: '20px 40px',
    fontWeight: '600',
    zIndex: 1100,
    boxShadow: '0 12px 30px rgba(0,0,0,0.15)',
    backdropFilter: 'blur(10px)'
  },

  paginationWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '40px 0',
    padding: '20px',
    background: 'rgba(255,255,255,0.05)',
    borderRadius: '16px',
    backdropFilter: 'blur(10px)'
  },

  pagination: {
    display: 'flex',
    listStyle: 'none',
    gap: '12px',
    padding: 0
  },

  pageButton: {
    padding: '12px 16px',
    border: '2px solid rgba(0,119,182,0.3)',
    borderRadius: '12px',
    backgroundColor: 'rgba(255,255,255,0.9)',
    cursor: 'pointer',
    fontWeight: '600',
    color: '#023e8a',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    minWidth: '44px',
    textAlign: 'center'
  },

  activePage: {
    background: 'linear-gradient(135deg, #0077b6 0%, #023e8a 100%)',
    color: '#fff',
    border: '2px solid #0077b6',
    boxShadow: '0 4px 12px rgba(0,119,182,0.4)'
  },

  ellipsis: {
    padding: '12px 16px',
    color: '#0077b6',
    fontWeight: '600'
  },

  filterHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    userSelect: 'none',
    padding: '8px 0',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
  },

  expandArrow: {
    fontSize: '20px',
    color: '#ffffff',
    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    fontWeight: '700',
    textShadow: '0 1px 2px rgba(0,0,0,0.2)'
  }
};

const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    background: 'rgba(45, 24, 16, 0.8)',
    backdropFilter: 'blur(8px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  },

  box: {
    background: 'linear-gradient(135deg, #fffcf8 0%, #faf6f0 100%)',
    padding: '40px',
    borderRadius: '24px',
    width: '800px',
    maxHeight: '85vh',
    overflowY: 'auto',
    position: 'relative',
    boxShadow: '0 25px 50px rgba(0,0,0,0.25), 0 0 0 1px rgba(212,165,116,0.2)',
    border: '1px solid rgba(212,165,116,0.15)'
  },

  closeButton: {
    position: 'absolute',
    top: '20px',
    right: '20px',
    fontSize: '28px',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    color: '#8b6b47',
    transition: 'color 0.2s ease',
    padding: '5px',
    borderRadius: '8px'
  },

  modalTitle: {
    marginBottom: '25px',
    color: '#3d2817',
    fontSize: '24px',
    fontWeight: '700',
    letterSpacing: '0.5px'
  },

  modalActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '20px',
    marginTop: '35px'
  },

  confirmButton: {
    padding: '14px 28px',
    background: 'linear-gradient(135deg, #81c784 0%, #4caf50 100%)',
    color: '#fff',
    border: 'none',
    borderRadius: '12px',
    fontWeight: '600',
    cursor: 'pointer',
    fontSize: '15px',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '0 6px 16px rgba(76,175,80,0.3)'
  },

  cancelButton: {
    padding: '14px 28px',
    background: 'linear-gradient(135deg, #d67b7b 0%, #c45a5a 100%)',
    color: '#fff',
    border: 'none',
    borderRadius: '12px',
    fontWeight: '600',
    cursor: 'pointer',
    fontSize: '15px',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '0 6px 16px rgba(214,123,123,0.3)'
  },

  saveButton: {
    padding: '14px 28px',
    background: 'linear-gradient(135deg, #0077b6 0%, #023e8a 100%)',
    color: '#fff',
    border: 'none',
    borderRadius: '12px',
    fontWeight: '600',
    cursor: 'pointer',
    fontSize: '15px',
    marginTop: '25px',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '0 6px 16px rgba(0,119,182,0.3)'
  }
};





export { styles, modalStyles };